var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('el-dialog', {
    attrs: {
      "visible": _setup.dialogVisible,
      "width": "500px",
      "custom-class": "dialog-airwallex",
      "close-on-press-escape": false,
      "close-on-click-modal": false,
      "top": "2vh"
    },
    on: {
      "update:visible": function ($event) {
        _setup.dialogVisible = $event;
      },
      "close": _setup.onDialogClose
    }
  }, [_setup.dialogVisible ? _c(_setup.Airwallex, {
    staticClass: "dialog-airwallex__dropin",
    attrs: {
      "intentId": _vm.data.intent_id,
      "clientSecret": _vm.data.client_secret,
      "currency": _vm.data.currency,
      "env": _vm.env
    },
    on: {
      "success": data => _setup.emit('success', data),
      "error": error => _setup.emit('error', error)
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };